import { Component, OnInit } from '@angular/core';
import { DataService } from '../../services/data.service';
import { BusinesLogicService } from '../../services/business-logic.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-postpone',
  templateUrl: './postpone.component.html',
  styleUrls: ['./postpone.component.css']
})
export class PostponeComponent implements OnInit {

  public turn:object;

  private destroy$ = new Subject();

  constructor(private _data:DataService,
              private _blogic:BusinesLogicService) {}

  ngOnInit() {
    this._updateTurn(this._data.turn);
    this._data.turnUpdate
    .pipe(takeUntil(this.destroy$))
    .subscribe(
      (response:object) => {
        this._updateTurn(response);
      }
    );
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private _updateTurn(turn:object):void {
    if (!this._data.turnIsActive()) {
      this.turn = null;
    } else {
      this.turn = turn;
    }
  }

  /* Recover finished turn */
  public postponeTurn():void {
    let params:object = {
        turn_id: this._data.turn["id"],
    };

    this._blogic.setPostpone(params)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (response:any) => {
          this._data.closeTurn();
        }
      );
  }

}
